export default "__VITE_ASSET__B09NsB6H__"